import {createRouter, createWebHistory} from 'vue-router'
import App from '../App'

const router = new createRouter({
    history: createWebHistory(),
    routes: [
        // dynamic segments start with a colon
        // {path: '/:segment([a-zA-Z]*:[a-zA-Z,\\s\\d-%]*)*',component:App, name:'segment'}
        {path:'/', component:App, name:"home"},
        {path: '/#search/:searchables?/:categories?/:chefs?/:programs?', component: App, name:'main'}
    ]
})
export default router;